import {
  Button,
  Dialog,
  DialogTitle,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { theme } from 'theme';

interface TermsDialogProps {
  open: boolean;
  urlPDF: string;
  onClose: () => void;
}

export function PopupDownloadPDF({
  open,
  onClose,
  urlPDF,
  ...rest
}: TermsDialogProps) {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open
      // onClose={onClose}
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          width: 350,
          height: 240,
          padding: 2,
          borderRadius: 4,
        },
      }}
      {...rest}
    >
      <DialogTitle sx={{ lineHeight: 'unset', textAlign: 'center' }}>
        <Typography
          variant="Web_Title_18"
          color={'primary.main'}
          textAlign={'center'}
        >
          Do you want to download
          <br /> Service Agreement?
        </Typography>
        <Typography fontWeight={400} fontSize={14} mt={2}>
          Service Agreement has been created!
        </Typography>
      </DialogTitle>

      <div
        style={{
          paddingTop: 20,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 10,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          style={{
            padding: 8,
            borderRadius: 5,
            maxHeight: 40,
            width: 96,
          }}
        >
          Cancel
        </Button>
        <a
          onClick={onClose}
          href={urlPDF}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: 8,
            backgroundColor: theme.palette.primary.main,
            borderRadius: 5,
            color: '#fff',
            textDecoration: 'none',
          }}
        >
          Download
        </a>
      </div>
    </Dialog>
  );
}

export default PopupDownloadPDF;
